import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { verifyEmail } from "../services/AuthService";

const VerifyEmail = () => {
  const [status, setStatus] = useState<string>("loading...");
  const navigate = useNavigate();

  const { userId, email, token } = useParams<{
    userId: string;
    email: string;
    token: string;
  }>();

  useEffect(() => {
    if (!userId || !email || !token) {
      navigate("/login");
      return;
    }

    (async () => {
      setStatus("verifying...");
      const verified = await verifyEmail({
        userId,
        email,
        token,
      });

      if (verified) {
        setStatus("verified!");
      }
    })();
  }, []);

  return <>{status}</>;
};

export default VerifyEmail;
